import { productImageCarouselStyles } from "@insite/content-library/Components/ProductImageCarousel";
import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { manufacturingPartNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";
import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            min-height: 300px;
            min-width: 200px;
            margin: 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #f2f3f5;
        `,
    },
};

priceStyles.productPrice!.price!.priceText = {
    css: css`
        color: #0000ff;
        font-weight: 700;
        font-size: 20px;
    `,
};

priceStyles.productPrice!.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        font-size: 14px;
        padding: 20px 15px 20px 0px;
    `,
};
addToListLinkStyles.wrapper = {
    css: css`
        margin-top: 10px;
        text-align: center;
    `,
};

addToCartButtonStyles.button = {
    variant: "primary",
    css: css`
        width: 100%;
    `,
};

partNumberStyles.labelText = {
    size: 16,
    weight: "bold",
    css: css`
        margin-right: 5px;
    `,
};

manufacturingPartNumberStyles.labelText = {
    size: 16,
    weight: "bold",
    css: css`
        margin-right: 5px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    margin-left: 15px;
                `,
            ])}
    `,
};

shareLinkStyles.wrapper = {
    css: css`
        margin-top: 0;
        position: absolute;
        top: 0;
        right: 20px;
        > button {
            width: 20px;
            height: 20px;
            text-indent: -9999px;
            background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18.039' height='19.877' viewBox='0 0 18.039 19.877'%3E%3Cg id='Icon_feather-share-2' data-name='Icon feather-share-2' transform='translate(-3.75 -2.25)'%3E%3Cpath id='Path_58' data-name='Path 58' d='M28.013,5.757A2.757,2.757,0,1,1,25.257,3a2.757,2.757,0,0,1,2.757,2.757Z' transform='translate(-6.974 0)' fill='none' stroke='%23001df5' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3E%3Cpath id='Path_59' data-name='Path 59' d='M10.013,16.257A2.757,2.757,0,1,1,7.257,13.5,2.757,2.757,0,0,1,10.013,16.257Z' transform='translate(0 -4.068)' fill='none' stroke='%23001df5' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3E%3Cpath id='Path_60' data-name='Path 60' d='M28.013,26.757A2.757,2.757,0,1,1,25.257,24,2.757,2.757,0,0,1,28.013,26.757Z' transform='translate(-6.974 -8.136)' fill='none' stroke='%23001df5' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3E%3Cpath id='Path_61' data-name='Path 61' d='M12.885,20.265l6.276,3.657' transform='translate(-3.249 -6.689)' fill='none' stroke='%23001df5' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3E%3Cpath id='Path_62' data-name='Path 62' d='M19.151,9.765l-6.266,3.657' transform='translate(-3.249 -2.621)' fill='none' stroke='%23001df5' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3E%3C/g%3E%3C/svg%3E")
                no-repeat;

            &:focus {
                outline: 0;
            }
        }
    `,
};

productPrimaryImageStyles.img = {
    css: css`
        max-width: 250px;
        max-height: 250px;
    `,
};

// modals css

primaryImageStyles.fullPrimaryImageModal = {
    cssOverrides: {
        modalContainer: css`
            width: auto;
        `,
        modalBody: css`
            width: auto;
            max-width: initial;
            max-height: initial !important;
        `,
        modalTitle: css`
            border-bottom: none;
            padding: 10px 10px 0;
        `,
        modalContent: css`
            text-align: center;
            min-width: 200px;
        `,
    },
};

primaryImageStyles.fullPrimaryImage = {
    image: {
        css: css`
            img {
                width: auto;
                max-height: 70vh;
            }
            & p {
                width: 50%;
            }
        `,
    },
};

// // pdp image Carousel

productImageCarouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        text-align: center;
        position: relative;
        padding: 10px 3px 0;
        height: 44px;
        > button {
            height: 34px;
        }
        > div {
            height: 34px;
            justify-content: center;
            > P {
                height: 19px;
            }
        }
    `,
};
